import { render, staticRenderFns } from "./RiskReports.vue?vue&type=template&id=437b8121"
import script from "./RiskReports.vue?vue&type=script&lang=js"
export * from "./RiskReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports